<div mat-dialog-title class="cust-modal-title">
  <h2 class="m-0">{{ parentData.title }}</h2>
  <button mat-icon-button mat-dialog-close>
    <mat-icon>close</mat-icon>
  </button>
</div>

<mat-dialog-content>
 
  <!-- end design end -->
  <mat-form-field appearance="outline" style="width: 100%;">
    <textarea
      [(ngModel)]="msg"
      matInput
      #userinput
      spellcheck="false"
      readonly
    ></textarea>
  </mat-form-field>
 
  <div class="copied_btn">
  <button
    mat-flat-button
    color="accent"
    *ngIf="copied"
    style="border: 1px solid #ffc107;">
    <mat-icon
      style="margin-right: 10px; position: relative;"
      class="material-icons-round"
      >
      done
    </mat-icon>
      <span>Copied</span>
  </button>
  </div>

 <div class="copied_btn">
  <button
    *ngIf="!copied"
    mat-button
    (click)="copyInputMessage(userinput)"
    style="
      border: 1px solid #ffc107;
      position: relative;
      color: #ffc107;">
    Copy link
  </button>
  </div>

</mat-dialog-content>